import React from "react";

const AppContextValue = {
	state: {
		auth: {
			email: "",
			name: "",
			signingOut: false,
			signingIn: true,
			permissions: Array<any>(),
		},
		currentUser: {} as any,
		menu: Array<any>(),
		settings: {} as any,
	},
	mutate: {} as any,
};

export { AppContextValue };

export default React.createContext(AppContextValue);
